import superjson from 'superjson';
import { z } from 'zod';

export const schema = z.object({ sessionId: z.string().min(1), todoId: z.string().min(1) });
export type InputType = z.infer<typeof schema>;

export type Candidate = {
  id: string;
  name: string;
  description: string;
  estMinutes: number;
  risk: 'low' | 'medium' | 'high';
  steps: string[];
  score?: number;
  rationale?: string;
};

export type OutputType = { candidates: Candidate[] };

export const proposeJudgement = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validated = schema.parse(body);
  const res = await fetch('/_api/todos/propose-judgement', {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validated),
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  if (!res.ok) {
    const err = superjson.parse(await res.text());
    throw new Error(err.error || 'Propose error');
  }
  return superjson.parse(await res.text());
};
